import { render } from "./UserSystemShow.vue?vue&type=template&id=20ac0d11"
import script from "./UserSystemShow.vue?vue&type=script&lang=js"
export * from "./UserSystemShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__